import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
export function Layout() {
  const {
    pathname
  } = useLocation();
  // Scroll to top on route change
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  return <div className="min-h-screen flex flex-col bg-engage-black text-engage-white font-sans selection:bg-engage-yellow selection:text-engage-black" data-id="element-55">
      <Navbar data-id="element-56" />
      <main className="flex-grow" data-id="element-57">
        <Outlet data-id="element-58" />
      </main>
      <Footer data-id="element-59" />
    </div>;
}